import { render } from "./CustomerQuotes.vue?vue&type=template&id=2a0e3fc1"
import script from "./CustomerQuotes.vue?vue&type=script&lang=js"
export * from "./CustomerQuotes.vue?vue&type=script&lang=js"

import "./CustomerQuotes.vue?vue&type=style&index=0&id=2a0e3fc1&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__